import { RootState } from "RootReducer";

export const getShouldShowCheckoutModalOnClick = (state) => !state.organization.hasChargebeeAccount;

export const getHasDownloadedLabels = (state: RootState): boolean => state.inbound.hasDownloadedLabels;
